import { Typography } from 'shared/ui'

import styles from './styles.module.scss'

export const RcsBadge = () => (
  <Typography variant='body-xs-regular' className={styles.badge} ariaLabel='RCS'>
    RCS
  </Typography>
)
